












































































import { Component, Watch, Vue } from 'vue-property-decorator';
import { debounce } from 'lodash-es';
import { ChatApi } from '@/services/api/api.chat';
import { ChatSearchViewModel, ChatMember } from '@/types/apiServerContract';

import GroupChatMember from './GroupChatMember.vue';

@Component({
    components: {
        GroupChatMember
    }
})
export default class GroupChatSearch extends Vue {
	searchMode: boolean = false;
	term: string = '';
	loading: boolean = false;
	debouncedSearch = debounce(this.search, 200);
	result: ChatSearchViewModel | null = null;
	selected: ChatMember[] = [];
	inputFocused: boolean = false;

	setFocus(state: boolean) {
	    this.inputFocused = state;
	}

	get showPopover() {
	    return this.result && this.result.members.length > 0 && this.inputFocused;
	}

	async search() {
	    if (this.term.length < 0) {
	        return;
	    }

	    this.loading = true;
	    this.result = null;

	    try {
	        const result = await ChatApi.Search(this.term);
	        this.result = result;
	    } finally {
	        this.loading = false;
	    }
	}

	@Watch('term')
	onTermChange(term: string, before: string) {
	    if (term.length > 0 && term !== before) {
	        this.debouncedSearch();
	    }
	}

	addMember(member: ChatMember) {
	    if (this.selected.findIndex(x => x.author === member.author) < 0) {
	        this.selected.push(member);

			this.result!.members.splice(this.result!.members.indexOf(member), 1);
	    }
	}

	removeMember(member: ChatMember) {
	    this.selected.splice(this.selected.indexOf(member), 1);
	}

	toggleMode(state: boolean) {
	    this.result = null;
	    this.selected = [];
	    this.term = '';

	    this.searchMode = state;
	}

	async startChat() {
	    this.loading = true;

	    try {
	        await ChatApi.CreateGroupChat({ members: this.selected.map(x => x.author) });
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast('Chat created succesfully', {
	        variant: 'success',
	        title: 'Success'
	    });

	    this.result = null;
	    this.selected = [];
	    this.term = '';
	}
}
